import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import Breakpoints from 'themes/constants/breakpoints';
import RoutePath from 'routes/constants/routes';
import useTranslate from 'hooks/useTranslate';
import { ReactComponent as GooglePlayLogoIcon } from 'media/icons/google-play-logo.svg';
import { ReactComponent as GooglePlayTextIcon } from 'media/icons/google-play-text.svg';
import { ReactComponent as AppleLogoIcon } from 'media/icons/apple-logo.svg';
import { ReactComponent as AppleTextIcon } from 'media/icons/apple-text.svg';
import * as DEFAULTS from 'constants/defaults';
import { useMediaQuery } from 'react-responsive';
import { APILinks } from 'constants/api';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import { IRootState, Languages } from 'constants/types';
import { States } from 'constants/states';
import {
  FooterContainer,
  FooterInner,
  FooterAppLinks,
  FooterAppLinksItem,
  FooterLinks,
  FooterCopyright,
  FooterLinkText,
} from './FooterStyles';

const Footer = forwardRef<HTMLDivElement>((props, ref) => {
  const currentYear = new Date().getFullYear();

  const [getText] = useTranslate();

  const isLaptop = useMediaQuery({ query: `(${Breakpoints.LAPTOP})` });

  const langState = useSelector((state: IRootState) => get(state, States.LANG));
  const langValue = get(langState, 'lang');

  const appLinks = (
    <FooterAppLinks>
      <FooterAppLinksItem href={APILinks.GOOGLE_PLAY_LINK}>
        <GooglePlayLogoIcon />
        <FooterLinkText uppercase>
          {langValue !== Languages.KZ ? (
            <span>
              {getText(['words', 'available'])}
            </span>
          ) : null}
          <GooglePlayTextIcon />
          {langValue === Languages.KZ ? (
            <span>
              {getText(['words', 'available'])}
            </span>
          ) : null}
        </FooterLinkText>
      </FooterAppLinksItem>
      <FooterAppLinksItem href={APILinks.APPLE_STORE_LINK}>
        <AppleLogoIcon />
        <FooterLinkText>
          {langValue !== Languages.KZ ? (
            <span>
              {getText(['words', 'upload'])}
            </span>
          ) : null}
          <AppleTextIcon />
          {langValue === Languages.KZ ? (
            <span>
              {getText(['words', 'upload'])}
            </span>
          ) : null}
        </FooterLinkText>
      </FooterAppLinksItem>
    </FooterAppLinks>
  );

  return (
    <FooterContainer ref={ref}>
      <FooterInner>
        {!isLaptop && appLinks}
        <FooterLinks>
          <Link to={RoutePath.ABOUT_PATH}>{getText(['footer', 'about'])}</Link>
          <Link to={RoutePath.OFFER_PATH}>{getText(['footer', 'offer'])}</Link>
          <Link to={RoutePath.FAQ_PATH}>{getText(['footer', 'faq'])}</Link>
        </FooterLinks>
        {isLaptop && appLinks}
        <FooterCopyright>
          {`${DEFAULTS.PROJECT_TITLE} © ${currentYear}`}
        </FooterCopyright>
      </FooterInner>
    </FooterContainer>
  );
});

export default Footer;
